import { Component, PendingTasks, inject, input, output, signal } from '@angular/core';
import { MobiUiIconComponent } from '@mobi/rwc-ui-components-ng-jslib';
import { IllustrationComponent } from '@app/components/illustration/illustration.component';
import { ComponentSharedModule } from '@app/modules/component.shared.module';
import { TextsService } from '@app/services/texts.service';

@Component({
  selector: 'mobi-concierge',
  templateUrl: './concierge.component.html',
  styleUrls: ['./concierge.component.scss'],
  standalone: true,
  imports: [ComponentSharedModule, MobiUiIconComponent, IllustrationComponent],
})
export class ConciergeComponent {
  contactUrl = signal('');

  #texts = inject(TextsService);
  #task = inject(PendingTasks);

  constructor() {
    const cleanup = this.#task.add();
    this.#texts
      .getText('contact_link_url', '404', '/privatpersonen/service-kontakt?page=kontakt')
      .then((text) => {
        this.contactUrl.set(text);
        cleanup();
      })
      .catch((e) => {
        console.log(e);
        cleanup();
      });
  }
}
